export default __webpack_public_path__ + "static/RayFortin-f26efd78cce4e06b899743e01380aa3e.jpg";